export const SET_MENU = '@customization/MENU_OPEN';
export const SET_STARTUP_DETAILS = '@customization/SET_STARTUP_DETAILS';
export const SET_PERMISSION_TEMPLATE = '@customization/SET_PERMISSION_TEMPLATE';
export const SET_USER_ACCESS = '@customization/SET_USER_ACCESS';
export const RESET_STATE = 'RESET_STATE';
export const SET_INVESTOR_TYPES = '@customization/SET_INVESTOR_TYPES';
export const SET_IS_SUBSCRIBED = '@customization/SET_IS_SUBSCRIBED';
export const SET_PROGRESS_DATA = '@customization/SET_PROGRESS_DATA';
export const DISMISS_SCORE_NOTICE = '@customization/DISMISS_SCORE_NOTICE';
export const SET_DATAROOMS_LIST = '@customization/SET_DATAROOMS_LIST';
export const SET_ROUNDS_LIST = '@customization/SET_ROUNDS_LIST';
export const SET_ALL_PLANS_DATA = '@customization/SET_ALL_PLANS_DATA';